const CNTypes = {
    CN_ACTION_START:"CN_ACTION_START",
    CN_FETCH_DATA:"CN_FETCH_DATA",
    CN_FETCH_DATA_FAILED:"CN_FETCH_DATA_FAILED",
    CN_ADD_DATA:"CN_ADD_DATA",
    CN_SOCKET_UPDATE_DATA: "CN_SOCKET_UPDATE_DATA"
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
    set_payload: ""
}

const CNReducer = (state=Initial_state, action) => {
    switch(action.type){
        case CNTypes.CN_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case CNTypes.CN_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload.data,
                set_payload: action.payload.set_payload
            }

        case CNTypes.CN_SOCKET_UPDATE_DATA:
            const { data, set_payload } = action.payload;
            if(state.set_payload !== set_payload){
                return {
                    ...state
                }
            }
            return {
                ...state,
                response: data
            }

        case CNTypes.CN_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }

        default:
            return state;
    }
};

export default CNReducer;